module.exports = __webpack_public_path__ + "static/img/logow.06edca7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logow.png
// module id = 7NkN
// module chunks = 3